export function mapStateToCopy({
  state,
  hasCheckInToday = false,
  hasActionCompletionToday = false,
  actionsCompleted7 = 0,
}) {
  if (state === "drift") {
    return {
      chip: "RESET TODAY",
      title: "Start small today.",
      body: "One small habit keeps today going.",
      tone: "warning",
    };
  }

  if (state === "reentry") {
    return {
      chip: "START AGAIN TODAY",
      title: "Start again today",
      body: "Pick this back up with one useful step.",
      tone: "positive",
    };
  }

  if (state === "dormant") {
    return {
      chip: "START SMALL",
      title: "Start small",
      body: "Begin with the smallest useful step today.",
      tone: "neutral",
    };
  }

  if (hasActionCompletionToday) {
    return {
      chip: "IN MOTION",
      title: actionsCompleted7 >= 3 ? "You're in motion." : "You started today.",
      body: "One small habit keeps today going.",
      tone: "positive",
    };
  }

  if (hasCheckInToday) {
    return {
      chip: "YOU SHOWED UP TODAY",
      title: "You showed up today",
      body: "You showed up. Now keep it simple with one small habit.",
      tone: "positive",
    };
  }

  return {
    chip: "START TODAY",
    title: "Today is ready.",
    body: "Start with one small habit that keeps today going.",
    tone: "positive",
  };
}
